import { getFullComposeViewState } from 'owa-calendar-compose-store-manager';
import type { LinkFile } from 'owa-calendar-compose-types';
import { addLinkFile, clearLinkFiles } from 'owa-calendar-compose-form-actions';
import { mutator } from 'satcheljs';

mutator(clearLinkFiles, actionMessage => {
    const fullViewState = getFullComposeViewState(actionMessage.formId);
    if (fullViewState) {
        fullViewState.linkFiles = [];
    }
});

mutator(addLinkFile, actionMessage => {
    const fullViewState = getFullComposeViewState(actionMessage.formId);
    if (fullViewState) {
        const linkFile: LinkFile = {
            linkId: actionMessage.linkId,
            providerId: actionMessage.providerId,
        };

        fullViewState.linkFiles.push(linkFile);
    }
});
